import React, { Component } from 'react';
import { TabPane, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { CustomKendoGrid } from '../shared/CustomKendoGrid';
import { GridColumn, GridColumnMenuFilter } from '@progress/kendo-react-grid';
import { CollapsibleCard } from '../shared/CollapsibleCard';
import { PersonalInfoItem } from './PersonalInfoItem';
import { DateUtils } from '../DateUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export class HRInformation extends Component {
    constructor(props) {
        super(props);
        this.dateUtils = new DateUtils();
        this.state = {
            user: {},
            employee: {},
            sb95ModalOpen: false,
            sb114ModalOpen: false
        };

        this.gridRef = null;
        this.setGridRef = element => {
            this.gridRef = element;
        };
        this.buildAbsenceInformation = this.buildAbsenceInformation.bind(this);
    }

    handleSB95ModalOpen = () => {
        this.setState((prevState) => {
            return {
                sb95ModalOpen: !prevState.sb95ModalOpen
            }
        })
    }

    handleSB114ModalOpen = () => {
        this.setState((prevState) => {
            return {
                sb114ModalOpen: !prevState.sb114ModalOpen
            }
        })
    }


    componentDidUpdate(prevProps) {
        if (!prevProps) return null;
        if (!this.props) return null;
        if (!this.gridRef) return null;
        if (prevProps.district !== this.props.district) {
            this.gridRef.handleDataCallback();
        }
        return null;
    }

    buildAbsenceInformation(label, property, symbol) {
        var value = ((this.props.absenceSummary || {})[property] || 0)
            .toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        let labelElement = (
            <div className='col-lg-3 col-md-4 col-sm-8 showdatalabel personalinfodata' key={1}>
                {symbol === undefined ? '' : <span className='reducesymbol'>{symbol}</span>}
                <span className='showdatalabel'>
                    {(label == 'SB95 COVID-19 Leave')
                        ? <Button color='link' className='text-right m-0 p-0' onClick={this.handleSB95ModalOpen} size="sm">{label}</Button>
                        : (label == 'SB114 Covid-19 Taken')
                            ? <Button color='link' className='text-right m-0 p-0' onClick={this.handleSB114ModalOpen} size="sm">{label}</Button>
                            : label}:
                </span>
            </div>);
        let valueElement = (
            <div className='col-lg-1 col-md-2 col-sm-4 showdatatext' key={2}><span>{value}</span>
            </div>)
        return [labelElement, valueElement];
    }

    render() {
        return (
            <>
                <TabPane tabId="3">
                    <CollapsibleCard title='Employee Information'>
                        <PersonalInfoItem title="Employee Status">{this.props.employee.jobStatus}</PersonalInfoItem>
                        <PersonalInfoItem title="Job Title">{this.props.employee.jobTitle}</PersonalInfoItem>
                        <PersonalInfoItem title="Job Code">{this.props.employee.jobCode}</PersonalInfoItem>
                        <PersonalInfoItem title="Job Category">{this.props.employee.jobCategoryName}</PersonalInfoItem>
                        <PersonalInfoItem title="Hire/Rehire Date">{this.dateUtils.formatDateFriendly(this.props.employee.hireDate, 'MMMM dd, yyyy')}</PersonalInfoItem>
                        <PersonalInfoItem title="TB Expiration">{this.dateUtils.formatDateFriendly(this.props.employee.tbExpiratioNDate, 'MMMM dd, yyyy')}</PersonalInfoItem>
                        <PersonalInfoItem title="Training - Mandatory Reporter">{this.dateUtils.formatDateFriendly(this.props.employee.mandatoryReporterTrainingDate, 'MMMM dd, yyyy')}</PersonalInfoItem>
                        <PersonalInfoItem title="Training - Sexual Harassment">{this.dateUtils.formatDateFriendly(this.props.employee.sexualHarassmentTrainingDate, 'MMMM dd, yyyy')}</PersonalInfoItem>
                    </CollapsibleCard>
                    {this.props.showAbsence &&
                        <CollapsibleCard title='Absence Information'>
                            <div className="container">
                                <div className="row">
                                    <div><FontAwesomeIcon icon="exclamation-triangle" color="orange" title="Alert icon" /> These values are for informational purposes only and may not reflect recent changes. Please contact your Human Resources department with any questions.  *Personal Necessity (PN) and Kin Care hours may only be used when Sick Leave is available.</div>
                                </div>
                                <div className="row margin-top-10">
                                    {this.buildAbsenceInformation("Sick Leave", 'sickLeave')}
                                    {this.buildAbsenceInformation("Vacation", 'vacation')}
                                    {this.buildAbsenceInformation("Discretionary Leave", 'discretionaryLeave', "*")}
                                    {this.buildAbsenceInformation("Personal Necessity", 'personalNecessityLeave', "*")}
                                    {this.buildAbsenceInformation("Comp Time", 'compTime')}
                                    {this.buildAbsenceInformation("FLSA Comp Time", 'flsaCompTime')}
                                    {this.buildAbsenceInformation("Kin Care", 'kinCareLeave', "*")}
                                    {this.buildAbsenceInformation("Industrial Accident", 'industrialAccident')}
                                    {this.buildAbsenceInformation("Sub (Hrs)", 'subHrs')}
                                    {this.buildAbsenceInformation("Business Leave", 'businessLeave', "**")}
                                    {this.buildAbsenceInformation("Adult Ed Sick Leave", 'adultEdSickLeave')}
                                    {this.buildAbsenceInformation("Sub (Days)", 'subDays')}
                                    {this.buildAbsenceInformation("Sick Leave AB1522 / SB616", 'sickLeaveAb1522')}
                                    {this.buildAbsenceInformation("Catastrophic Leave", 'catastrophicLeave')}
                                    {this.buildAbsenceInformation("SB95 COVID-19 Leave", 'sB95CovidTotal')}
                                    {this.buildAbsenceInformation("SB114 Covid-19 Taken", 'sB114CovidTotal')}
                                </div>
                                <div className='row margin-top-10'>
                                    <div className='col-6 reducesickleavetext'>*Does reduce Sick Leave Total</div>
                                    <div className='col-6 reducesickleavetext'>**May reduce Sick Leave Total</div>
                                </div>
                            </div>
                            <CustomKendoGrid
                                ref={this.setGridRef}
                                refreshData={this.props.absenceInfoCb}>
                                <GridColumn width="105" title="From" field="fromDate" columnMenu={GridColumnMenuFilter} filter="date" format="{0:MM/dd/yyyy}" />
                                <GridColumn width="105" title="To" field="toDate" columnMenu={GridColumnMenuFilter} filter="date" format="{0:MM/dd/yyyy}" />
                                <GridColumn width="75" title="Hours" field="hours" filter="numeric" columnMenu={GridColumnMenuFilter} />
                                <GridColumn title="Description" field="codeDescription" columnMenu={GridColumnMenuFilter} />
                            </CustomKendoGrid>
                        </CollapsibleCard>
                    }
                </TabPane>
                <Modal isOpen={this.state.sb95ModalOpen} toggle={this.handleSB95ModalOpen} size="lg" style={{ maxWidth: '1600px', width: '60%', margin: '10px auto' }}>
                    <ModalHeader toggle={this.handleSB95ModalOpen}>
                        SB-95 COVID-19 Supplemental Paid Sick Leave Statement
                    </ModalHeader>
                    <ModalBody>
                        Effective March 29, 2021, SB 95 establishes supplemental paid sick leave provisions for employees who are unable to report to work or work from home for reasons related to the COVID-19 pandemic. Full-time Employees may qualify for up to two weeks (not to exceed 80 hours) supplemental leave time. Employees who are not full-time are entitled to leave based on their standard work schedule or a variable work schedule. SB 95 caps SPSL benefits at a rate of $511 per day that may limit your available SPSL leave balance. SPSL is retroactive to January 1, 2021 and ends September 30, 2021. The SB 95 COVID-19 Leave field provides you a summary of your outstanding SB 95 SPSL balance as of the most current payroll period. If you have questions regarding this information, please contact your employer.
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.handleSB95ModalOpen}>Close</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.sb114ModalOpen} toggle={this.handleSB114ModalOpen} size="lg" style={{ maxWidth: '1600px', width: '60%', margin: '10px auto' }}>
                    <ModalHeader toggle={this.handleSB114ModalOpen}>
                        SB114 Covid-19
                    </ModalHeader>
                    <ModalBody>
                        Effective February 19, 2022, SB 114 establishes supplemental paid sick leave provisions for employees who are unable to report to work for reasons related to the COVID-19 pandemic. Full-time Employees may qualify for up to two weeks (not to exceed 80 hours) supplemental leave time with supporting documentation. Employees who are not full-time are entitled to leave based on their standard work schedule or a variable work schedule. SB 114 caps SPSL benefits at a rate of $511 per day that may limit your available SPSL leave balance. SPSL is retroactive to January 1, 2022 and ends September 30, 2022. <b>Assembly Bill 152 continues the availability of COVID-19 supplemental paid sick leave for covered employees through December 31, 2022</b>.  Below is a summary of your SB 114 SPSL activity as of the most current payroll period. If you have questions regarding this information, please contact your Human Resources Department.
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.handleSB114ModalOpen}>Close</Button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}